window.AudioContext = window.AudioContext || window.webkitAudioContext;

let context = false;

if (window.AudioContext) {
  context = new window.AudioContext();
}

const notesMap = {
  rest: 0,
  G4: 392,
  A4: 440,
  C5: 523.25,
  E5: 659.26,
  F5: 698.46,
  D5: 587.33,
  G5: 783.99,
  A5: 880.00,
  C6: 1046.5,
};

const masterLimiter = createLimiter();
const masterGainNode = context.createGain();

masterGainNode.connect(masterLimiter);
masterLimiter.connect(context.destination);

masterGainNode.gain.value = 0.4;

function playNote(note, duration, type, delay) {
  const oscillator = context.createOscillator();
  const gainNode = context.createGain();

  const startTime = context.currentTime + (delay / 1000);
  const stopTime = startTime + (duration / 1000);

  oscillator.frequency.value = notesMap[note];
  oscillator.type = type;
  oscillator.start(startTime);
  oscillator.stop(stopTime);

  gainNode.gain.value = (oscillator.type === 'sine' || oscillator.type === 'triangle') ? 0.4 : 0.1;

  // fade just before stop time to prevent pops
  gainNode.gain.setTargetAtTime(0, (stopTime - 0.08), 0.01);

  oscillator.connect(gainNode);
  gainNode.connect(masterGainNode);
}

function playNotes(notes, type, delay, duration, callback) {
  duration = duration || 200;

  if (notes.length > 0) {
    let note = notes.shift();

    if (typeof note === 'object') {
      [note, duration] = note;
    }

    if (callback) {
      const remainingNotes = notes.length;

      setTimeout(() => {
        callback(note, remainingNotes);
      }, delay);
    }

    playNote(note, duration, type, delay);
    playNotes(notes, type, delay + duration + 10, duration, callback);
  }
}

function createLimiter() {
  const limiter = context.createDynamicsCompressor();

  limiter.threshold.value = 0.0; // this is the pitfall, leave some headroom
  limiter.knee.value = 0.0; // brute force
  limiter.ratio.value = 20.0; // max compression
  limiter.attack.value = 0.005; // 5ms attack
  limiter.release.value = 0.050; // 50ms release

  return limiter;
}

function abcNotes() {
  return [
    ['C5', 300],
    ['C5', 300],
    ['G5', 300],
    ['G5', 300],
    ['A5', 300],
    ['A5', 300],
    ['G5', 300],

    ['rest', 300],
    ['F5', 300],
    ['F5', 300],
    ['E5', 300],
    ['E5', 300],
    ['D5', 150],
    ['D5', 150],
    ['D5', 150],
    ['D5', 150],
    ['C5', 300],
    ['C6', 300],
  ];
}

function notes123() {
  return [
    ['A5', 200],
    ['G5', 200],
    ['A5', 200],
    ['C6', 400],
    ['A5', 400],
    ['E5', 200],
    ['E5', 200],
    ['D5', 200],
    ['E5', 200],
    ['G5', 400],
    ['E5', 400],

    ['A4', 200],
    ['A4', 200],
    ['G4', 200],
    ['A4', 400],

    ['rest', 400],
    ['G5', 200],
    ['A5', 400],
    ['G5', 200],
    ['E5', 200],
    ['G5', 200],
    ['E5', 200],
    ['G5', 200],
    ['A5', 400],
  ];
}

export default {
  playNotes,
  abcNotes,
  notes123,
};



// WEBPACK FOOTER //
// ./src/js/notes.js